import { FlightBookingHelperService } from './../flight-booking-helper/flight-booking-helper.service';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { ApiErrorService } from '../api-error.service';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { AccountService } from '../user/account.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class FlightBookingService {
  apiParams: any;
  seatMapLoading$ = new BehaviorSubject<boolean>(false);
  private seatMapDataSubject = new BehaviorSubject<{
    responseStatus: any;
    segments: any[];
  } | null>(null);
  seatMapData$ = this.seatMapDataSubject.asObservable();

  setSeatMapData(data: { responseStatus: any; segments: any[] }) {
    this.seatMapDataSubject.next(data);
  }

  constructor(
    private httpClient: SmartHttpService,
    private envService: TxService,
    private helperService: HelperService,
    private accountService: AccountService,
    private apiErrorService: ApiErrorService,
    private flightBookingHelperService: FlightBookingHelperService,
    private location: Location,
  ) {
    this.initApiParams();
  }

  public set flightBookingSearchRequestApi(value: string) {}

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get flightBookingSearchRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.flightBookingSearchRequestApi = `${this.envService.flightBookingSearchRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set flightBookingReviewApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get flightBookingReviewApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.getFlightBookingReviewApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set flightBookingHistoryApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get flightBookingHistoryApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.getFlightBookingHistoryApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set flightBookingDetailApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get flightBookingDetailApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.getFlightBookingDetailApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set generatePaymentTokensApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get generatePaymentTokensApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.generatePaymentTokensApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set releaseBookingApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get releaseBookingApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.releaseBookingApi = `${this.envService.releaseBookingApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set cancelBookingApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get cancelBookingApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.cancelBookingApi = `${this.envService.cancelFlightBookingApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set checkBookingStatusApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get checkBookingStatusApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.checkBookingStatusApi = `${this.envService.checkBookingStatusApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set flightFareRulesApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get flightFareRulesApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.flightFareRulesApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set bookFlightRequestApi(value: string) {}

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get bookFlightRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.bookFlightRequestApi = `${this.envService.bookFlightRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set createFlightBookingRequestApi(value: string) {}

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get createFlightBookingRequestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // eslint-disable-next-line max-len
    return (this.bookFlightRequestApi = `${this.envService.createFlightBookingRequestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set addUserActionApi(value: string) {}

  public get addUserActionApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.addUserActionApi = `${this.envService.addUserActionApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set getCarouselsApi(value: string) {}
  public set getPublicCarouselsApi(value: string) {}
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get getCarouselsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.getCarouselsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public get getPublicCarouselsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.flightBookingReviewApi = `${this.envService.getPublicCarouselsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public flightBookingSearchRequest(data, page, sortBy = '', perpage = 12, fareType?: 'flexi_cancel' | '') {
    if (data) {
      const queryToSave = JSON.parse(JSON.stringify(data));
      this.flightBookingHelperService.saveSearchQuery = queryToSave;
    }
    data.airlinePreference =
      data?.airlinePreference?.length > 0
        ? data?.airlinePreference?.map((item) => item?.airlineCode)
        : [];

    if (fareType === 'flexi_cancel') {
      this.apiParams.fareType = 'flexi_cancel';
      data = { ...data, fareType: 'flexi_cancel' };
    } else {
      delete this.apiParams.fareType;
      if (data && typeof data === 'object') {
        const { fareType: _ignored, ...rest } = data;
        data = rest;
      }
    }
    this.apiParams.page = page;
    this.apiParams.sortby = sortBy;
    this.apiParams.perpage = perpage;
    return this.httpClient.postWithErorrHandler(
      this.flightBookingSearchRequestApi,
      data
    );
  }

  public flightBookingReviewRequest(resultId, isFareExpired?: boolean, fareType?: 'flexi_cancel' | '') {
    if (fareType === 'flexi_cancel') {
      this.apiParams.fareType = 'flexi_cancel';
    } else {
      delete this.apiParams.fareType;
    }
    this.apiParams.resultId = resultId;
    this.apiParams.fareExpired = isFareExpired ? true : false;
    return this.httpClient.getWithErorrHandler(this.flightBookingReviewApi);
  }

  public getFlightBookingHistoryRequest(page, count, flexiBooking = false) {
    this.apiParams.page = page;
    this.apiParams.count = count;
    
    if (flexiBooking) {
      this.apiParams.flexiBooking = 1;
    } else {
      delete this.apiParams.flexiBooking;
    }

    return this.httpClient.getWithErorrHandler(this.flightBookingHistoryApi);
  }

  public bookFlightRequest(data, bookingId?: string, paymentIntentId?: string) {
    // this.initApiParams();
    // this.apiParams.currency = 'USD';
    this.apiParams.bookingId = bookingId || '';
    // this.apiParams.paymentIntentId = paymentIntentId || '';
    data.paymentIntentId = paymentIntentId || '';
    return this.httpClient.postWithErorrHandler(
      this.bookFlightRequestApi,
      data
    );
  }
  public generatePaymentTokensRequest(bookingId?: string) {
    this.apiParams.bookingId = bookingId;
    return this.httpClient.getWithErorrHandler(this.generatePaymentTokensApi);
  }

  public createFlightBookingRequest(data,camapaignId: number,fareType?: 'flexi_cancel' | '') {
    this.apiParams.campaignId = camapaignId;
    if (fareType === 'flexi_cancel') {
      this.apiParams.fareType = 'flexi_cancel';
      data = { ...data, fareType: 'flexi_cancel' };
    } else {
      delete this.apiParams.fareType;
      if (data && typeof data === 'object') {
        const { fareType: _ignored, ...rest } = data;
        data = rest;
      }
    }
    const origin = location.origin;
    const path = this.location.path().split('?')[0]; // remove query params
    this.apiParams.redirect_url = origin + path;
    return this.httpClient.postWithErorrHandler(
      this.createFlightBookingRequestApi,
      data
    );
  }

  public flightBookingDetailRequest(bookingId) {
    this.apiParams.bookingId = bookingId;
    return this.httpClient.getWithErorrHandler(this.flightBookingDetailApi);
  }

  public releaseBookingRequest(bookingId) {
    this.apiParams.bookingId = bookingId;
    return this.httpClient.getWithErorrHandler(this.releaseBookingApi);
  }

  public checkBookingStatusRequest(bookingId) {
    this.initApiParams();
    this.apiParams.bookingId = bookingId;
    return this.httpClient.get(this.checkBookingStatusApi);
  }

  public flightFareRulesRequest(resultId) {
    this.apiParams.resultId = resultId;
    return this.httpClient.getWithErorrHandler(this.flightFareRulesApi);
  }

  sendFlightBookingEmail(bookingId: string): Observable<any> {
    this.initApiParams();
    this.apiParams.action_name = 'email_booking';
    this.apiParams.action_type = 'flight_booking';
    this.apiParams.action_id = bookingId;
    return this.httpClient.get(this.addUserActionApi);
  }

  public cancelFlightBookingRequest(bookingId) {
    this.apiParams.bookingId = bookingId;
    return this.httpClient.getWithErorrHandler(this.cancelBookingApi);
  }

  initApiParams() {
    this.apiParams = {
      page: 1,
      perpage: 20,
      city: '',
    };
  }

  // Add this method for seatMap API
  public get seatMapApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return `${this.envService.getSeatMapApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`;
  }

  public seatMapRequest(payload: any) {
    this.seatMapLoading$.next(true);
    return this.httpClient.post(this.seatMapApi, payload).pipe(
      finalize(() => {
        this.seatMapLoading$.next(false);
      })
    );
  }

  public getCarousels(slug, type?: string, sendDefaultTab?: number): Observable<any> {
    this.initApiParams();
    this.apiParams.slug = slug;
    this.apiParams.type = type || 'tab';
    this.apiParams.sendDefaultTab = sendDefaultTab || 0;

    return this.httpClient.get(this.getCarouselsApi);
  }

  public getPublicCarousels(slug, type?: string, sendDefaultTab?: number): Observable<any> {
    this.initApiParams();
    this.apiParams.slug = slug;
    this.apiParams.type = type || 'tab';
    this.apiParams.sendDefaultTab = sendDefaultTab || 0;

    return this.httpClient.get(this.getPublicCarouselsApi);
  }
}
